import { CellTypeNames } from '../../../../../../../common/table/CellTypeConstants';
import { CellData, CellTypeFormatChanges, CellTypeObject, TableChangeSource } from '../../../../../../../common/table/TableTypes';
import { updateCellType } from '../../dataUtils/cell/tableCellTypeUpdateUtils';
import type { MNHotInstance } from '../../../../bridge/tableHotInstanceTypes';
import { getNormalisedComputedCellValueFromHot } from './hotTableCellRenderValueUtils';
import { updateHotTableSelectedCellData } from '../../../../bridge/utils/hotInstanceUtils/cell/hotTableCellUpdateUtils';

/** Updates a cell type using live HoT data needed to validate formula-backed values. */
const updateHotCellType = (
    hot: MNHotInstance | null | undefined,
    prevCellData: CellData,
    cellTypeName: CellTypeNames,
    currencyPreference: string,
    elementId: string,
    row: number | undefined,
    col: number | undefined,
): CellData => {
    if (!hot) return prevCellData;

    const { locale } = hot.milanoteProps;
    const normalisedComputedCellValue = getNormalisedComputedCellValueFromHot(elementId, row, col, hot);

    return updateCellType(prevCellData, cellTypeName, currencyPreference, locale, normalisedComputedCellValue);
};

/** Updates the cell-type formatting for the selected cells in the active HOT instance. */
export const updateHotTableSelectedCellTypeFormat = (
    hotInstance: MNHotInstance,
    cellTypeFormatChanges: CellTypeFormatChanges,
): void =>
    updateHotTableSelectedCellData(
        hotInstance,
        (cellData: CellData) => {
            if (!cellData.type) return cellData;

            return {
                ...cellData,
                type: { ...cellData.type, ...cellTypeFormatChanges } as CellTypeObject,
            };
        },
        TableChangeSource.CELL_META_UPDATE_CELL_TYPE_FORMAT,
    );

/** Updates selected cells using live HoT data needed to resolve computed formula values. */
export const updateHotTableSelectedCellType = (
    hotInstance: MNHotInstance,
    elementId: string,
    cellType: CellTypeNames,
    currencyPreference: string,
): void =>
    updateHotTableSelectedCellData(
        hotInstance,
        (cellData: CellData, row?: number, col?: number) =>
            updateHotCellType(hotInstance, cellData, cellType, currencyPreference, elementId, row, col),
        TableChangeSource.CELL_META_UPDATE_CELL_TYPE,
    );
